import {CurrencyPipe, TitleCasePipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TranslationService} from '@emma-labs/shared/angular';
import {MIBIAIReport} from '@emma-labs/shared/typescript';
import {TableModule} from 'primeng/table';
import {formatOptionalCountryStateAndTerritory} from '../utils';

@Component({
  selector: 'em-iai-section',
  templateUrl: './iai-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, CurrencyPipe, TitleCasePipe],
})
export class IAISectionComponent {
  @Input({required: true}) data!: MIBIAIReport[];

  constructor(private readonly translate: TranslationService) {}

  getResidencePlace(report: MIBIAIReport) {
    return formatOptionalCountryStateAndTerritory(
      report.residenceCountry,
      report.residenceState,
      report.residenceTerritory,
      this.translate.getCurrentLanguageCode(),
    );
  }
}
